import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { Chart } from 'chart.js';
import { MatDialog } from '@angular/material/dialog';
import { DashboardDevicesTypesZoomCardComponent } from '../dashboard-devices-types-zoom-card/dashboard-devices-types-zoom-card.component';

@Component({
  selector: 'app-dashboard-devices-types-card',
  templateUrl: './dashboard-devices-types-card.component.html',
  styleUrls: ['./dashboard-devices-types-card.component.scss']
})
export class DashboardDevicesTypesCardComponent implements OnInit, AfterViewInit {

  @ViewChild('devicesType', { static: false }) devicesTypeRef: ElementRef;
  @Input() data;
  @Input() colors;
  @Input() title;
  ctx;
  chart;

  constructor(private dialog: MatDialog) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.ctx = this.devicesTypeRef.nativeElement.getContext('2d');
    this.renderChart(this.data);
  }

  public statZoom() {
    this.dialog.open(DashboardDevicesTypesZoomCardComponent, { data: { data: this.data, title: this.title, colors: this.colors } } );
  }

  private renderChart(data) {

    if (this.chart) {
      this.chart.destroy();
    }
    this.chart = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: data.map(d => d.label),
        datasets: [
          {
            data: data.map(d => d.nbActiveTrue),
            backgroundColor: this.colors[3],
            hoverBackgroundColor: this.colors[3],
            label: 'ON'
          },
          {
            data: data.map(d => d.nbActiveFalse),
            backgroundColor: this.colors[1],
            hoverBackgroundColor: this.colors[1],
            label: 'OFF'
          },
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            gridLines: {
              display: true,
              color: '#eeeeee',
              drawBorder: false
            },
            ticks: {
              padding: 20,
              fontColor: '#aaaaaa',
              beginAtZero: true,
              stepSize: 1
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: '#aaaaaa'
            }
          }]
        },
        legend: {
          display: true,
          position: 'bottom',
          align: 'end',
          fontColor: '#aaaaaa'
        }
      },
      plugins: [{
        id: 'total',
        afterDraw: (chart) => {
          if (!(data.map(d => d.label).length > 0)) {
            const width = chart.width;
            const height = chart.height;
            const ctx = chart.ctx;
            ctx.restore();
            const text1 = 'Not found';
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(width / 2 - ctx.measureText(text1).width / 2 - 30, height / 2 - 65, ctx.measureText(text1).width + 60, 50);
            ctx.fillStyle = '#aaaaaa';
            ctx.font = '14px sans-serif';
            ctx.fillText(text1, width / 2 - (ctx.measureText(text1).width / 2), height / 2 - 40);
            ctx.save();
          }
        }
      }]
    });
  }

}
